import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 5px;

  div {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    margin-right: 10px;
  }

  div:first-child {
    margin: 0;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 50px;
    border-radius: 50%;
    background: var(--info-transparent);
  }
`;
